import { ModuleWithProviders, NgModule } from '@angular/core';
import { RecommenderChatComponent } from './recommender-chat.component';
import { RecommendationChatComponent } from './components/recommendation-chat/recommendation-chat.component';
import { InputPanelComponent } from './components/input-panel/input-panel.component';
import { EnvironmentConfig } from './services/recommendation-services.service';
import { CatalogRecommenderComponent } from './components/catalog-recommender/catalog-recommender.component';
import { CatalogNodeComponent } from './components/catalog-recommender/catalog-node/catalog-node.component';
import { CommonModule } from '@angular/common';
import { OutputPanelComponent } from './components/output-panel/output-panel.component';


@NgModule({
  declarations: [
    RecommenderChatComponent
  ],
  imports: [
    CommonModule,
    RecommendationChatComponent,
    InputPanelComponent,
    CatalogRecommenderComponent,
    CatalogNodeComponent,
    OutputPanelComponent
  ],
  exports: [
    RecommenderChatComponent,RecommendationChatComponent,InputPanelComponent,CatalogRecommenderComponent,CatalogNodeComponent,OutputPanelComponent
  ]
})
export class RecommenderChatModule { 
  static forRoot(config: EnvironmentConfig): ModuleWithProviders<RecommenderChatModule> {
    return {
      ngModule: RecommenderChatModule,
      providers: [
        { provide: 'ENVIRONMENT_CONFIG', useValue: config }
      ]
    };
  }
}
